import { render, staticRenderFns } from "./SupplyChainSupplierRanking.vue?vue&type=template&id=112d79b0&scoped=true&"
import script from "./SupplyChainSupplierRanking.vue?vue&type=script&lang=js&"
export * from "./SupplyChainSupplierRanking.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainSupplierRanking.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SupplyChainSupplierRanking.vue?vue&type=style&index=1&id=112d79b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112d79b0",
  null
  
)

export default component.exports